import * as React from 'react';

export const SupportCode = ({ code }: { code: string | null }) => {
  if (code === null) return null;

  return (
    <span className="flex justify-center" data-cy="support-code">
      [{code}]
    </span>
  );
};
